import { useMutation, useSuspenseQuery } from "@tanstack/react-query";
import type { UpdateProfileDto, UpdateProfilePasswordDto } from "shared";
import { Api } from "../api.config";
import { AlertType, useAlertEmit } from "../common/alert/Alert";
import { QueryKeys } from "../LinkGen";

export const useProfile = () => {
	const emit = useAlertEmit();

	const { data } = useSuspenseQuery({
		queryKey: QueryKeys.Profile(),
		queryFn: () => Api.Profile().then((x) => x.data),
	});

	const updateUserInfo = useMutation({
		mutationFn: async (x: UpdateProfileDto) => {
			await Api.UpdateProfile(x);
			emit({
				type: AlertType.SUCCESS,
				content: "You have updated your profile!",
			});
		},
	});

	const updateUserPassword = useMutation({
		mutationFn: async (x: UpdateProfilePasswordDto) => {
			await Api.UpdateProfilePassword(x);
			emit({
				type: AlertType.SUCCESS,
				content: "You have changed your password!",
			});
		},
	});

	return {
		profile: data,
		updateUserInfo,
		updateUserPassword,
	};
};
